import {
  ExecutePianoProps,
  useExecutePiano,
} from "~/components/Piano/useExecutePiano";

export const ExecutePiano: React.FC<ExecutePianoProps> = (props) => {
  useExecutePiano(props);
  return null;
};
